$(function(){
	$("#menuBtn").on("click", function(){
		$(this).toggleClass("isActive");
		$(this).hasClass("isActive") ? $("#recGlobalNavi").addClass("isVisible") : $("#recGlobalNavi").removeClass("isVisible");
	});
	
	$("#recGlobalNavi").find("a").on("click", function(){
		$("#recGlobalNavi").removeClass("isVisible");
		$("#menuBtn").removeClass("isActive");
	});
	
	$(".proSlide").slick({
		slidesToShow: 1,
		centerMode: true,
		centerPadding: "300px",
		variableWidth: true,
		responsive: [
			{
				breakpoint: 768,
				settings: {
					centerPadding: "30px"
                }
			}
		]
	});
	
	$(".faqBtn").on("click", function(){
		let target = $(this).parents("dl").find("dd");
		target.slideToggle();
		$(this).parent("dt").toggleClass("active");
	});
	
	$("a[href^='#']").click(function(){
		var speed = 600;
		var href= $(this).attr("href");
		var target = $(href === "#" || href === "" ? 'html' : href);
		var position = target.offset().top;
		$("html, body").animate({scrollTop:position}, speed, "swing");
		return false;
	});

});

$(window).on("load", function(){
	$("#fvCatch").addClass("onLoad");
});